export const STATISTICS = "/"
export const ADD_PARTNER = "/addPartner"
export const USERS = "/users"
export const ALL_ARTIST = "/allArtist";
export const LOGIN = "/login";
export const NEWS = "/news"
export const ADD_NEWS = "/addNews"
export const ADD_PODCAST = "/podcast"
export const CREATE_PODCAST="/createPodcast"
export const VERIFY_NEWS = "/verifyNews"
export const VERIFY_PODCAST = "/verifyPodcast"
export const VERIFIED_USER = "/verifiedUser"
export const UNVERIFIED_USER = "/unverifiedUser"
export const PENDING_USER = "/pendingUser"
